/* tslint:disable */
/* eslint-disable */
export enum UploadDocumentConflictType {
  UserNotAllowedToUploadDocuments = 'user_not_allowed_to_upload_documents',
  UserVerificationNotFound = 'user_verification_not_found',
  UserVerificationNotInProgress = 'user_verification_not_in_progress',
  DocumentAlreadyUploaded = 'document_already_uploaded'
}
